import React from "react"
import Layout from "../components/layouts/Default"
import Container from "../components/layouts/container/Container"

export default function Page({ data, location }) {
  return (
    <Layout location={location} title="Nachricht gesendet" desc="">
      <Container className="my-8 mmd:my-16">
        <div className="text-lg max-w-prose mx-auto">
          <h1 className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Nachricht gesendet
          </h1>
          <div className="mt-8 text-xl text-gray-500 leading-8 prose text-center">
            <p>Wir melden uns bei Dir.</p>
          </div>
        </div>
      </Container>
    </Layout>
  )
}
